import { NextPage } from "next"
import Head from "next/head"
import { useRouter } from "next/router"
import { DefaultLayout } from "src/components/Layout"
import { PartnerPreRegistrationList } from "src/features/partner-pre-registration/components/PartnerPreRegistrationList"

const PartnerPreRegistrationListPage: NextPage = () => {
  const router = useRouter()
  if (!router.isReady) {
    return null
  }
  const rawStatuses = router.query.statuses
  const defaultStatuses =
    rawStatuses === undefined
      ? ["in_review", "in_compliance_review", "checking"]
      : Array.isArray(rawStatuses)
      ? rawStatuses
      : rawStatuses.split(",")
  return (
    <DefaultLayout>
      <Head>
        <title>加盟店申し込み一覧 | for CS</title>
      </Head>
      <div className="bg-gray-50" style={{ height: "calc(100vh - 90px)" }}>
        <div className="mx-auto max-w-10/12 px-4 py-6 sm:px-6 lg:px-8">
          {/* ページヘッダー */}
          <h1 className="text-3xl font-bold text-gray-900">加盟店申し込み一覧</h1>

          {/* メインコンテンツ */}
          <div className="rounded-lg bg-white shadow-sm">
            <div className="p-6">
              <PartnerPreRegistrationList defaultStatuses={defaultStatuses} />
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}

export default PartnerPreRegistrationListPage
